export const addresses = {
  svgHelperAddress:"0xaD2Fdff8A7F11B2450c70ba93A2F26AdDa89Bc7C",
  splatterAddress:"0x68e44d106b5178b4C79201A8283c0f3e4619505d",
  splatterArtAddress:"0x15993662556bd062f0Af819B780A62AEC0D528Ba",
  splatterToken:"0x873c4bf04E3569bba917b85Bf3fE930DEaF87eAF"
}
